<div class="clients-container px-[16px] py-[32px] md:p-[80px] bg-gray-50 flex flex-col w-full h-full gap-[32px] md:gap-[64px]">
    <div class="flex items-start xl:gap-[24px] flex-col xl:flex-row">
        <div class="clients-header">
            <div class="clients-title">Let’s see what our</div>
            <div class="clients-sub-title">Clients Say.</div>
        </div>
        <div class="clients-header-content">Backed by deep expertise, diverse skill sets, and unwavering team stability, we consistently exceed client and stakeholder expectations—elevating every project to new heights of success.</div>
    </div>
    <div class="carousel-container carousel-track-destop h-[524px] hidden xl:block">
        <div data-index="0" [ngStyle]="getStyleDesktop(0)" class="carousel-slide-destop p-[48px] flex gap-[64px] rounded-[20px] h-[524px] bg-white">
            <div class="flex flex-col justify-between w-[176px] shrink-[0]">
                <img src="../../../assets/images/clients-say/Xenial.png" width="125" height="40" alt="Xenial" />
                <div class="flex flex-col gap-[36px]">
                    <div class="h-px clients-content-divider"></div>
                    <div class="flex flex-col gap-[20px]">
                        <div>
                            <div class="client-content-business">Business Area</div>
                            <div class="client-content-catering">Catering</div>
                        </div>
                        <div class="flex flex-col gap-[4px]">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="client-content-img-desktop desktop-xenial">
                <div class="flex justify-between flex-col px-[36px] py-[48px] h-full client-content-img-content">
                    <div class="flex gap-[16px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="22" height="16" />
                        <p>
                            In the fast-paced world of event planning, a clunky booking system kills momentum. CDS built us a sleek, user-friendly platform that handles ticket sales, seat selection, and real-time event updates seamlessly. During our
                            biggest annual tournament, the system processed 10,000+ bookings without a hitch—no crashes, no delays. Their Agile team even added last-minute features like dynamic pricing for peak demand. Now, attendees rave about the
                            booking experience, and we’ve seen a 20% surge in repeat registrations. For any event organizer, this is the tech edge you need to win.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Tushar Dabhade</div>
                        <div>Sr Director, Software Development</div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="1" [ngStyle]="getStyleDesktop(1)" class="carousel-slide-destop p-[48px] flex gap-[64px] rounded-[20px] h-[524px] bg-white">
            <div class="flex flex-col justify-between w-[176px] shrink-[0]">
                <img src="../../../assets/images/clients-say/Sentral.png" width="137" height="50" alt="Sentral" />
                <div class="flex flex-col gap-[36px]">
                    <div class="h-px clients-content-divider"></div>
                    <div class="flex flex-col gap-[20px]">
                        <div>
                            <div class="client-content-business">Business Area</div>
                            <div class="client-content-catering">School Management</div>
                        </div>
                        <div class="flex flex-col gap-[4px]">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="client-content-img-desktop desktop-sentral">
                <div class="flex justify-between flex-col px-[36px] py-[48px] h-full client-content-img-content">
                    <div class="flex gap-[16px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="22" height="16" />
                        <p>
                            For years, our school struggled with siloed systems—enrollment, attendance, and resource booking were chaotic. CDS changed everything. Their team designed a campus management system that centralizes every process, from
                            student onboarding to faculty scheduling. The intuitive dashboards gave us real-time insights, cutting administrative errors by 35% and freeing staff to focus on education, not paperwork. What stood out? Their commitment
                            to understanding our unique academic workflows—no generic software, just a solution built for our community.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Matthew Arnold</div>
                        <div>Development Manager</div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="2" [ngStyle]="getStyleDesktop(2)" class="carousel-slide-destop p-[48px] flex gap-[64px] rounded-[20px] h-[524px] bg-white">
            <div class="flex flex-col justify-between w-[176px] shrink-[0]">
                <img src="../../../assets/images/clients-say/ECSI.png" width="90" height="30" alt="ECSI" />
                <div class="flex flex-col gap-[36px]">
                    <div class="h-px clients-content-divider"></div>
                    <div class="flex flex-col gap-[20px]">
                        <div>
                            <div class="client-content-business">Business Area</div>
                            <div class="client-content-catering">Higher Education</div>
                        </div>
                        <div class="flex flex-col gap-[4px]">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="client-content-img-desktop desktop-ecsi">
                <div class="flex justify-between flex-col px-[36px] py-[48px] h-full client-content-img-content">
                    <div class="flex gap-[16px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="22" height="16" />
                        <p>
                            During the implementation, their Agile development approach meant we could make adjustments on the fly as we discovered new requirements. Since going live, the efficiency of our lending operations has increased
                            significantly. Loan processing time has been reduced by 40%, and the error rate in loan applications has dropped to an all-time low. For any educational institution looking to streamline campus lending, CDS is the partner
                            you can trust.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Edsel Lu</div>
                        <div>Director, Enterprise Architecture and Software Engineering</div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="3" [ngStyle]="getStyleDesktop(3)" class="carousel-slide-destop p-[48px] flex gap-[64px] rounded-[20px] h-[524px] bg-white">
            <div class="flex flex-col justify-between w-[176px] shrink-[0]">
                <img src="../../../assets/images/clients-say/Ezidebit.png" width="135" height="36" alt="Ezidebit" />
                <div class="flex flex-col gap-[36px]">
                    <div class="h-px clients-content-divider"></div>
                    <div class="flex flex-col gap-[20px]">
                        <div>
                            <div class="client-content-business">Business Area</div>
                            <div class="client-content-catering">Payment Solution</div>
                        </div>
                        <div class="flex flex-col gap-[4px]">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="client-content-img-desktop desktop-ezidebit">
                <div class="flex justify-between flex-col px-[36px] py-[48px] h-full client-content-img-content">
                    <div class="flex gap-[16px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="22" height="16" />
                        <p>
                            CDS didn’t just ‘build software’—they architected a future-proof payment infrastructure. Their developers mastered complex API integrations, ensuring seamless transactions across 20+ geographies. Meanwhile, the security
                            team embedded AI-driven fraud detection that cut chargeback rates by 18% in the first quarter post-launch.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Partrick King</div>
                        <div>Chief Technology Officer - Payments</div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="4" [ngStyle]="getStyleDesktop(4)" class="carousel-slide-destop p-[48px] flex gap-[64px] rounded-[20px] h-[524px] bg-white">
            <div class="flex flex-col justify-between w-[176px] shrink-[0]">
                <img src="../../../assets/images/clients-say/Heartland.png" width="125" height="40" alt="Heartland" />
                <div class="flex flex-col gap-[36px]">
                    <div class="h-px clients-content-divider"></div>
                    <div class="flex flex-col gap-[20px]">
                        <div>
                            <div class="client-content-business">Business Area</div>
                            <div class="client-content-catering">Human Capital Management</div>
                        </div>
                        <div class="flex flex-col gap-[4px]">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="client-content-img-desktop desktop-heartland">
                <div class="flex justify-between flex-col px-[36px] py-[48px] h-full client-content-img-content">
                    <div class="flex gap-[16px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="22" height="16" />
                        <p>
                            I wanted to take a moment to celebrate all of the work that you have done over the last few weeks. Whether it’s working on an individual finding, doing research, working on the Macroscope - to - DevOps integration, or
                            tackling several findings at once, all of you have played a part in this success so far. I’m genuinely impressed.‘
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Adam Cole</div>
                        <div>Director, Software Development</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="carousel-container carousel-track-tablet h-[716px] hidden md:block xl:hidden">
        <div data-index="0" [ngStyle]="getStyle(0)" class="carousel-slide-tablet py-[40px] px-[32px] flex flex-col gap-[40px] rounded-[20px] bg-white">
            <img src="../../../assets/images/clients-say/Xenial.png" width="125" height="40" alt="Xenial" />
            <div class="client-content-img-tablet tablet-xenial h-[464px]">
                <div class="flex justify-between flex-col px-[36px] py-[48px] h-full client-content-img-content">
                    <div class="flex gap-[16px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="22" height="16" />
                        <p>
                            In the fast-paced world of event planning, a clunky booking system kills momentum. CDS built us a sleek, user-friendly platform that handles ticket sales, seat selection, and real-time event updates seamlessly. During our
                            biggest annual tournament, the system processed 10,000+ bookings without a hitch—no crashes, no delays. Their Agile team even added last-minute features like dynamic pricing for peak demand. Now, attendees rave about the
                            booking experience, and we’ve seen a 20% surge in repeat registrations. For any event organizer, this is the tech edge you need to win.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Tushar Dabhade</div>
                        <div>Sr Director, Software Development</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-[16px]">
                <div class="h-px clients-content-divider"></div>
                <div class="flex gap-[20px]">
                    <div class="flex-1">
                        <div class="client-content-business">Business Area</div>
                        <div class="client-content-catering">Catering</div>
                    </div>
                    <div class="flex-1">
                        <div class="flex flex-col">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="1" [ngStyle]="getStyle(1)" class="carousel-slide-tablet py-[40px] px-[32px] flex flex-col gap-[40px] rounded-[20px] bg-white">
            <img src="../../../assets/images/clients-say/Sentral.png" width="137" height="50" alt="Sentral" />
            <div class="client-content-img-tablet tablet-sentral h-[464px]">
                <div class="flex justify-between flex-col px-[36px] py-[48px] h-full client-content-img-content">
                    <div class="flex gap-[16px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="22" height="16" />
                        <p>
                            For years, our school struggled with siloed systems—enrollment, attendance, and resource booking were chaotic. CDS changed everything. Their team designed a campus management system that centralizes every process, from
                            student onboarding to faculty scheduling. The intuitive dashboards gave us real-time insights, cutting administrative errors by 35% and freeing staff to focus on education, not paperwork. What stood out? Their commitment
                            to understanding our unique academic workflows—no generic software, just a solution built for our community.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Matthew Arnold</div>
                        <div>Development Manager</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-[16px]">
                <div class="h-px clients-content-divider"></div>
                <div class="flex gap-[20px]">
                    <div class="flex-1">
                        <div class="client-content-business">Business Area</div>
                        <div class="client-content-catering">School Managament</div>
                    </div>
                    <div class="flex-1">
                        <div class="flex flex-col">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="2" [ngStyle]="getStyle(2)" class="carousel-slide-tablet py-[40px] px-[32px] flex flex-col gap-[40px] rounded-[20px] bg-white">
            <img src="../../../assets/images/clients-say/ECSI.png" width="90" height="30" alt="ECSI" />
            <div class="client-content-img-tablet tablet-ecsi h-[464px]">
                <div class="flex justify-between flex-col px-[36px] py-[48px] h-full client-content-img-content">
                    <div class="flex gap-[16px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="22" height="16" />
                        <p>
                            During the implementation, their Agile development approach meant we could make adjustments on the fly as we discovered new requirements. Since going live, the efficiency of our lending operations has increased
                            significantly. Loan processing time has been reduced by 40%, and the error rate in loan applications has dropped to an all-time low. For any educational institution looking to streamline campus lending, CDS is the partner
                            you can trust.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Edsel Lu</div>
                        <div>Director, Enterprise Architecture and Software Engineering</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-[16px]">
                <div class="h-px clients-content-divider"></div>
                <div class="flex gap-[20px]">
                    <div class="flex-1">
                        <div class="client-content-business">Business Area</div>
                        <div class="client-content-catering">Higher Education</div>
                    </div>
                    <div class="flex-1">
                        <div class="flex flex-col">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="3" [ngStyle]="getStyle(3)" class="carousel-slide-tablet py-[40px] px-[32px] flex flex-col gap-[40px] rounded-[20px] bg-white">
            <img src="../../../assets/images/clients-say/Ezidebit.png" width="135" height="36" alt="Ezidebit" />
            <div class="client-content-img-tablet tablet-ezidebit h-[464px]">
                <div class="flex justify-between flex-col px-[36px] py-[48px] h-full client-content-img-content">
                    <div class="flex gap-[16px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="22" height="16" />
                        <p>
                            CDS didn’t just ‘build software’—they architected a future-proof payment infrastructure. Their developers mastered complex API integrations, ensuring seamless transactions across 20+ geographies. Meanwhile, the security
                            team embedded AI-driven fraud detection that cut chargeback rates by 18% in the first quarter post-launch.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Partrick King</div>
                        <div>Chief Technology Officer - Payments</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-[16px]">
                <div class="h-px clients-content-divider"></div>
                <div class="flex gap-[20px]">
                    <div class="flex-1">
                        <div class="client-content-business">Business Area</div>
                        <div class="client-content-catering">Payment Solution</div>
                    </div>
                    <div class="flex-1">
                        <div class="flex flex-col">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="4" [ngStyle]="getStyle(4)" class="carousel-slide-tablet py-[40px] px-[32px] flex flex-col gap-[40px] rounded-[20px] bg-white">
            <img src="../../../assets/images/clients-say/Heartland.png" width="125" height="40" alt="Heartland" />
            <div class="client-content-img-tablet tablet-heartland h-[464px]">
                <div class="flex justify-between flex-col px-[36px] py-[48px] h-full client-content-img-content">
                    <div class="flex gap-[16px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="22" height="16" />
                        <p>
                            I wanted to take a moment to celebrate all of the work that you have done over the last few weeks. Whether it’s working on an individual finding, doing research, working on the Macroscope - to - DevOps integration, or
                            tackling several findings at once, all of you have played a part in this success so far. I’m genuinely impressed.‘
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Adam Cole</div>
                        <div>Director, Software Development</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-[16px]">
                <div class="h-px clients-content-divider"></div>
                <div class="flex gap-[20px]">
                    <div class="flex-1">
                        <div class="client-content-business">Business Area</div>
                        <div class="client-content-catering">Human Capital Management</div>
                    </div>
                    <div class="flex-1">
                        <div class="flex flex-col">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="carousel-container carousel-track-mobile h-[488px] md:hidden">
        <div data-index="0" [ngStyle]="getStyle(0)" class="carousel-slide-mobile p-[16px] flex flex-col gap-[16px] rounded-[20px] bg-white">
            <img src="../../../assets/images/clients-say/Xenial.png" width="62" height="20" alt="Xenial" />
            <div class="client-content-img-mobile mobile-xenial h-[352px]">
                <div class="flex justify-between flex-col p-[20px] h-full client-content-img-content">
                    <div class="flex gap-[8px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="11" height="8" />
                        <p>
                            In the fast-paced world of event planning, a clunky booking system kills momentum. CDS built us a sleek, user-friendly platform that handles ticket sales, seat selection, and real-time event updates seamlessly. During our
                            biggest annual tournament, the system processed 10,000+ bookings without a hitch—no crashes, no delays. Their Agile team even added last-minute features like dynamic pricing for peak demand. Now, attendees rave about the
                            booking experience, and we’ve seen a 20% surge in repeat registrations. For any event organizer, this is the tech edge you need to win.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Tushar Dabhade</div>
                        <div>Sr Director, Software Development</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-[16px]">
                <div class="h-px clients-content-divider"></div>
                <div class="flex gap-[16px]">
                    <div class="flex-1">
                        <div class="client-content-business">Business Area</div>
                        <div class="client-content-catering">Catering</div>
                    </div>
                    <div class="flex-1">
                        <div class="flex flex-col">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="1" [ngStyle]="getStyle(1)" class="carousel-slide-mobile p-[16px] flex flex-col gap-[16px] rounded-[20px] bg-white">
            <img src="../../../assets/images/clients-say/Sentral.png" width="68" height="25" alt="Sentral" />
            <div class="client-content-img-mobile mobile-sentral h-[352px]">
                <div class="flex justify-between flex-col p-[20px] h-full client-content-img-content">
                    <div class="flex gap-[8px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="11" height="8" />
                        <p>
                            For years, our school struggled with siloed systems—enrollment, attendance, and resource booking were chaotic. CDS changed everything. Their team designed a campus management system that centralizes every process, from
                            student onboarding to faculty scheduling. The intuitive dashboards gave us real-time insights, cutting administrative errors by 35% and freeing staff to focus on education, not paperwork. What stood out? Their commitment
                            to understanding our unique academic workflows—no generic software, just a solution built for our community.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Matthew Arnold</div>
                        <div>Development Manager</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-[16px]">
                <div class="h-px clients-content-divider"></div>
                <div class="flex gap-[16px]">
                    <div class="flex-1">
                        <div class="client-content-business">Business Area</div>
                        <div class="client-content-catering">School Managament</div>
                    </div>
                    <div class="flex-1">
                        <div class="flex flex-col">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="2" [ngStyle]="getStyle(2)" class="carousel-slide-mobile p-[16px] flex flex-col gap-[16px] rounded-[20px] bg-white">
            <img src="../../../assets/images/clients-say/ECSI.png" width="50" height="20" alt="ECSI" />
            <div class="client-content-img-mobile mobile-ecsi h-[352px]">
                <div class="flex justify-between flex-col p-[20px] h-full client-content-img-content">
                    <div class="flex gap-[8px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="11" height="8" />
                        <p>
                            During the implementation, their Agile development approach meant we could make adjustments on the fly as we discovered new requirements. Since going live, the efficiency of our lending operations has increased
                            significantly. Loan processing time has been reduced by 40%, and the error rate in loan applications has dropped to an all-time low. For any educational institution looking to streamline campus lending, CDS is the partner
                            you can trust.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Edsel Lu</div>
                        <div>Director, Enterprise Architecture and Software Engineering</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-[16px]">
                <div class="h-px clients-content-divider"></div>
                <div class="flex gap-[16px]">
                    <div class="flex-1">
                        <div class="client-content-business">Business Area</div>
                        <div class="client-content-catering">Higher Education</div>
                    </div>
                    <div class="flex-1">
                        <div class="flex flex-col">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="3" [ngStyle]="getStyle(3)" class="carousel-slide-mobile p-[16px] flex flex-col gap-[16px] rounded-[20px] bg-white">
            <img src="../../../assets/images/clients-say/Ezidebit.png" width="68" height="20" alt="Ezidebit" />
            <div class="client-content-img-mobile mobile-ezidebit h-[352px]">
                <div class="flex justify-between flex-col p-[20px] h-full client-content-img-content">
                    <div class="flex gap-[8px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="11" height="8" />
                        <p>
                            CDS didn’t just ‘build software’—they architected a future-proof payment infrastructure. Their developers mastered complex API integrations, ensuring seamless transactions across 20+ geographies. Meanwhile, the security
                            team embedded AI-driven fraud detection that cut chargeback rates by 18% in the first quarter post-launch.
                        </p>
                    </div>
                    <div>
                        <div class="client-content-img-content-bold">Partrick King</div>
                        <div>Chief Technology Officer - Payments</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-[16px]">
                <div class="h-px clients-content-divider"></div>
                <div class="flex gap-[16px]">
                    <div class="flex-1">
                        <div class="client-content-business">Business Area</div>
                        <div class="client-content-catering">Payment Solution</div>
                    </div>
                    <div class="flex-1">
                        <div class="flex flex-col">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div data-index="4" [ngStyle]="getStyle(4)" class="carousel-slide-mobile p-[16px] flex flex-col gap-[16px] rounded-[20px] bg-white">
            <img src="../../../assets/images/clients-say/Heartland.png" width="67" height="20" alt="Heartland" />
            <div class="client-content-img-mobile mobile-heartland h-[352px]">
                <div class="flex justify-between flex-col p-[20px] h-full client-content-img-content">
                    <div class="flex gap-[8px] flex-col">
                        <img src="../../../assets/images/clients-say/Vector.png" width="11" height="8" />
                        <p>
                            I wanted to take a moment to celebrate all of the work that you have done over the last few weeks. Whether it’s working on an individual finding, doing research, working on the Macroscope - to - DevOps integration, or
                            tackling several findings at once, all of you have played a part in this success so far. I’m genuinely impressed.‘
                        </p>
                    </div>
                    <div class="flex gap-[8px] flex-col">
                        <div class="client-content-img-content-bold">Adam Cole</div>
                        <div>Director, Software Development</div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-[16px]">
                <div class="h-px clients-content-divider"></div>
                <div class="flex gap-[16px]">
                    <div class="flex-1">
                        <div class="client-content-business">Business Area</div>
                        <div class="client-content-catering">Human Capital Management</div>
                    </div>
                    <div class="flex-1">
                        <div class="flex flex-col">
                            <div class="client-content-business">Reviews</div>
                            <div class="flex gap-[8px] items-center">
                                <img src="../../../assets/images/clients-say/Stars.png" width="76" height="12" />
                                <span class="text-xs">5.0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="carousel-nav self-center pt-[16px] md:pt-[0px]" data-index="{currentIndex}">
        <div class="nav-dot active" (click)="clickDot(0)" data-index="0"></div>
        <div class="nav-dot" (click)="clickDot(1)" data-index="1"></div>
        <div class="nav-dot" (click)="clickDot(2)" data-index="2"></div>
        <div class="nav-dot" (click)="clickDot(3)" data-index="3"></div>
        <div class="nav-dot" (click)="clickDot(4)" data-index="4"></div>
    </div>
</div>
